module.exports = __webpack_public_path__ + "img/visa.1faafad3.png";